import React, { useContext, useEffect } from 'react';
import './App.css';
import Login from './сomponents/login-authorization/Login';
import RenderBlock from './сomponents/render-block/Render-component';
import { BrowserRouter as BrowserRouter } from 'react-router-dom';
import { ContextData } from './context/Data/ContextData';

const App = () => {
  const { data, setData } = useContext(ContextData);
  useEffect(() => {
    if (typeof localStorage.access_token !== 'undefined' && localStorage.access_token !== null) {
      setData(true);
    }
  }, []);

  return (
    <>
      <BrowserRouter>{data ? <RenderBlock /> : <Login />}</BrowserRouter>
    </>
  );
};

export default App;
